import { render, staticRenderFns } from "./Departmental-issues.vue?vue&type=template&id=62e3b64a"
import script from "./Departmental-issues.vue?vue&type=script&lang=js"
export * from "./Departmental-issues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports